module.exports = __webpack_public_path__ + "static/img/polygon_logo.6935d4ad.png";